module.exports = __webpack_public_path__ + "static/media/summer.6d7197f1.jpg";